import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '@app/core/log/log.service';
import { DEFAULT_LANG, SUPPORTED_LANGS, SupportedLang } from '../i18n/supported-langs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly _currentLang = signal<SupportedLang>(DEFAULT_LANG);
  private readonly translate = inject(TranslateService);
  readonly currentLang = this._currentLang.asReadonly();

  constructor() {
    this.init();
  }

  init(): void {
    this.translate.addLangs(SUPPORTED_LANGS);
    const saved = localStorage.getItem('lang') as SupportedLang;
    const lang = SUPPORTED_LANGS.includes(saved) ? saved : DEFAULT_LANG;
    this.setLang(lang);
  }

  setLang(lang: SupportedLang): void {
    if (!SUPPORTED_LANGS.includes(lang)) {
      LogService.warn(`Language not supported: ${lang}`);
      return;
    }
    this._currentLang.set(lang);
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang;
  }
}
